import dataAttribute from '@wavevision/ts-utils/dom/dataAttribute';

export const DISALLOW_MULTIPLE_SUBMITS = dataAttribute(
  'disallow-multiple-submits',
);
